/** Styles for the Sources screen and the onboarding email step. `src-` prefix, tokens only. */
export const SOURCES_CSS = `
.src-page { display: flex; flex-direction: column; gap: var(--space-3); }
.src-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: var(--space-3); }
.src-card {
  display: flex; flex-direction: column; gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: var(--bg2); border: 1px solid var(--border); border-radius: var(--radius);
}
.src-card.is-current { border-color: var(--accent, var(--border)); }
.src-card-head { display: flex; align-items: center; justify-content: space-between; gap: var(--space-2); flex-wrap: wrap; }
.src-card-name { margin: 0; font-size: var(--text-base); font-weight: 600; color: var(--text); }
.src-badges { display: flex; gap: var(--space-1); flex-wrap: wrap; }
.src-line { display: flex; gap: var(--space-2); align-items: baseline; font-size: var(--text-base); color: var(--text); }
.src-kind { font-size: var(--text-xs); text-transform: uppercase; letter-spacing: .06em; color: var(--text-muted); min-width: 48px; }
.src-value { overflow-wrap: anywhere; }
.src-dim, .src-meta { color: var(--text-muted); font-size: var(--text-sm, 12px); }
.src-meta { margin: 0; }
.src-error { color: var(--red); font-size: var(--text-sm, 12px); white-space: pre-wrap; }
.src-actions { display: flex; flex-wrap: wrap; gap: var(--space-2); }
.src-actions .add-btn { margin-left: 0; }
.src-boxes { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: var(--space-2); }
.src-box {
  display: flex; flex-direction: column; gap: var(--space-1);
  padding: var(--space-2) var(--space-3); border: 1px solid var(--border); border-radius: var(--radius);
}
.src-box .src-line { justify-content: space-between; }
.src-providers { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: var(--space-2); }
.src-provider {
  display: flex; align-items: center; justify-content: space-between; gap: var(--space-3);
  padding: var(--space-2) var(--space-3); border: 1px dashed var(--border); border-radius: var(--radius);
}
.src-provider .add-btn { margin-left: 0; flex-shrink: 0; }
.src-provider-name { font-weight: 600; font-size: var(--text-base); color: var(--text); }
.src-provider-hint { font-size: var(--text-sm, 12px); color: var(--text-muted); }
.src-foot { margin: 0; font-size: var(--text-sm, 12px); color: var(--text-muted); max-width: 560px; line-height: 1.5; }
`
